var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_6fedc000"]},_vm.$listeners),[_c('cube-button',{attrs:{"open-type":"launchApp","app-parameter":"xxx","tip":"需在微信小程序环境预览"},on:{"launchApp":(e)=>_vm.__invoke(e, [["onLaunchApp"]])}},[_vm._v("打开 APP")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }